export default __webpack_public_path__ + "static/media/Mark-3-Suit-10.939434e9.jpg";